<template>
  <div data-grm-comp="RoomCall" class="room-call-component relative"
    v-if="roomDataInitComplete"
  >
    <div class="room-call">
      <RoomCallMixing
          v-if="isMixingCallType"
          :secondVideo="secondVideo"
          :videoOnly="videoOnly"
      />
      <RoomCallCamStudyP2P v-if="isCamStudy" :videoOnly="videoOnly" :pip="pip" />
      <RoomCallP2P
          v-else-if="isP2PCallType"
          :videoOnly="videoOnly"
          :pip="pip"
      />
      <RoomCallP2P
          v-if="isMixerSFUCallType"
          :videoOnly="videoOnly"
          :pip="pip"
      />

      <template v-if="pip">
        <RoomCallNewWindow
            v-if="isMixingCallType"
        />
      </template>

    </div>

    <div class="room-call-other">
      <RoomCallSpeechText :stt="stt" :translation="translation"/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

import RoomCallP2P from "@/components/Room/Call/p2p/RoomCallP2P";
import RoomCallMixing from "@/components/Room/Call/mixing/RoomCallMixing";
import RoomCallNewWindow from "@/components/Room/Call/newWindow";
import RoomCallSpeechText from "@/components/Room/Call/RoomCallSpeechText";
import RoomCallCamStudyP2P from "@/components/Room/Call/p2p/RoomCallCamStudyP2P.vue";

export default {
  name: 'RoomCall',
  components: {
    RoomCallCamStudyP2P,
    RoomCallP2P,
    RoomCallMixing,
    RoomCallNewWindow,
    RoomCallSpeechText

  },
  data() {
    return {
      stt: {
        show: false,
        text: '',
        timeoutId: null,
      },
      translation: {
        show: false,
        text: '',
        timeoutId: null,
      },
    }
  },
  props: {
    secondVideo: {
      type: Boolean,
      default: false
    },
    videoOnly: {
      type: Boolean,
      default: false
    },
    pip: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('room', ['roomDataInitComplete', 'isRoomMode', 'isCamStudy']),
    ...mapGetters('call', [
      'callType',
      'isP2PCallType',
      'isMixingCallType',
      'isMixerSFUCallType'
    ]),
    ...mapGetters('user', [
      'me',
      'getUsername'
    ]),
    ...mapGetters('roomGroup', [
      'getRoomGroupName'
    ]),
    ...mapGetters('translation', [
        'translationState'
    ])
  },
  created() {
    if(!this.pip)
      this.$roomApi.addEventListeners(this._Events = Events(), this);
  },
  destroyed() {
    this._Events && this.$roomApi.removeEventListeners(this._Events);
  },
  methods: {}
}

function Events() {
  return {
    add_stt_text(e) {
      const {data: {text}} = e;
      this.stt.text = text;
      this.stt.show = true;
      
      clearTimeout(this.stt.timeoutId);
      this.stt.timeoutId = setTimeout(()=>{
        this.stt = {
          text: '',
          show: false,
          timeoutId: null,
        }
      }, 5000)
    },
    add_translation_text(e) {
      const {
        data: {
          translateData: { translatedText },
        },
        userId,
      } = e

      const item = {
        name: this.getUsername(userId),
        text: translatedText,
      }

      this.translation.name = `[${item.name}]`
      this.translation.text = item.text
      this.translation.show = true

      clearTimeout(this.translation.timeoutId);
      this.translation.timeoutId = setTimeout(()=>{
        this.translation = {
          name: '',
          text: '',
          show: false,
          timeoutId: null,
        }
      }, 5000)
    },
    add_translation_text_error(e) {
      const {
        data: {
          translateErrorData: { errType, errCode, errMsg },
        },
        userId,
      } = e

      const item = {
        name: this.getUsername(userId),
        text: `ErrType:[${errType}], ErrCode:[${errCode}], ErrMsg:[${errMsg}]`,
      }

      this.translation.name = `[${item.name}]`
      this.translation.text = item.text
      this.translation.show = true

      clearTimeout(this.translation.timeoutId);
      this.translation.timeoutId = setTimeout(()=>{
        this.translation = {
          name: '',
          text: '',
          show: false,
          timeoutId: null,
        }
      }, 5000)
    }
  }
}
</script>

<style lang="scss" scoped>
.room-call {
  height: 100%;
  position: relative;
}

// component
.room-group-setting-button {
  position: absolute;
  top: 10px;
  left: 20px;
  z-index: 1;
}
</style>